theme = theme || {};
theme.currencyConverter = function(mode, oldCurrency, newCurrency, selector, format){
  if(mode == 'select'){
    Currency.convertAll(oldCurrency, newCurrency, selector, format);
  } else {
    var cookieCurrency = Currency.cookie.read() || theme.shopCurrency;
    var currencySelectorVal = jQuery(document).find(theme.currencySelector).attr('data-currency');
    var newCurrencySymbol = jQuery(document).find('.form-field-select a[data-value="'+cookieCurrency+'"]').data('symbol') || cookieCurrency;
    var notConvertedYet = jQuery(document).find('#relatedProductsSwiper').data('limit') || 0;
    if(cookieCurrency == currencySelectorVal) return;
    //console.log(currencySelectorVal);
    jQuery(document).find(theme.currencySelector).attr('data-currency', cookieCurrency);
    jQuery(document).find(theme.currencySelector).html(newCurrencySymbol+' <i class="lin lin-arrow-down"></i>');
    Currency.convertAll(currencySelectorVal, cookieCurrency, 'span.money', 'money_format');
    var convertAllPrice = setInterval(function(){
      if(notConvertedYet > 0){
        Currency.convertAll(currencySelectorVal, cookieCurrency, 'span.money', 'money_format');
        notConvertedYet -= 1; 
      } else {
        clearInterval(convertAllPrice);
      }
    }, 500);
  }
}
const CustomFilterSliderActivePosition = (parentElement) => {
  if(parentElement.querySelector(".eg-logos-2 .story-card.eg-active")){
    const acItem = parentElement.querySelector(`.eg-logos-2 .story-card.eg-active`);
    let tabwidth = acItem.offsetWidth;
    parentElement.querySelector(`.eg-logos-2 .eg-tabs-nav__position`).style.cssText = '--width:' + tabwidth + 'px;--prevWidth:' + (acItem.offsetLeft) + 'px;';
    acItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }
}
jQuery(function($){
 if(document.querySelectorAll(".eg-logos-2").length> 0){
   document.querySelectorAll(".eg-logos-2").forEach((el) => {
     const mainId = el.dataset.main;
     const mainElement = document.querySelector(`.${mainId}`);
     CustomFilterSliderActivePosition(mainElement);
   });
   
 } 

  var swiper = new Swiper('.theme-default-featured-collection-wrapper .collection-row-swiper', {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    // init: false,
    navigation: {
      nextEl: '.theme-default-featured-collection-wrapper .swiper-next',
      prevEl: '.theme-default-featured-collection-wrapper .swiper-prev',
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
    }
  });
var swiper2 = new Swiper('.custom-main-filter-products .collection-filter-row-swiper', {
    slidesPerView: 1.2,
    spaceBetween: 10,
    loop: true,
    // init: false,
    navigation: {
      nextEl: '.custom-main-filter-products .swiper-next',
      prevEl: '.custom-main-filter-products .swiper-prev',
    },
    breakpoints: {
      640: {
        slidesPerView: 1.2,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2.2,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
    }
  });

  
  $(document).on("click",".eg-logos-2 .story-card",function(){
    const mainPrent = $(this).parents(".eg-logos-2");
    const mainId = mainPrent.data("main");
    const filter_id = $(this).data("id");
    $(`.${mainId} .story-card`).removeClass("eg-active");
    $(this).addClass("eg-active");
    $(`.${mainId} .custom-main-filter-products`).addClass("hidden");
    $(`.${mainId} .custom-main-filter-products[data-id="${filter_id}"]`).addClass("active-main");
    $(`.${mainId} .custom-main-filter-products[data-id="${filter_id}"]`).removeClass("hidden");
    window.dispatchEvent(new Event("resize"));
    const mainElement = document.querySelector(`.${mainId}`);
     CustomFilterSliderActivePosition(mainElement);
  });
  
  if( $('#page-header').hasClass('page-header')) {
    $(document.body).addClass('banner-enabled');
  }
  
  //Custom tag filter
  $('.category-filters-area-list').click(function() {
    //$('.category-filters-area-list').toggleClass('open-list');
    $(this).parent().toggleClass("open-list");
    return false;
  });
  
  $('.select-brand').click(function() {
    $('.select-brand').toggleClass('show-brands');
    $(this).next().slideToggle(200);
  });
  
  
  //Product tab
  $('ul.tabs li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('ul.tabs li').removeClass('active');
    $('.tab-content').removeClass('active');

    $(this).addClass('active');
    $("#"+tab_id).addClass('active');
  });
  
  //Product accordion 
  $(".accordion-wrap").each(function(){  
    $(this).find(".accordion -content").hide();
    $(".accordion-content.active").show();
  });

  $(".accordion-wrap").each(function(){
    $(this).find(".accordion-heading").click(function() {
      $('.accordion-heading').removeClass('active').next().slideUp(200); 
      $(this).toggleClass("active").next().stop(true, false).slideToggle(200);      
      return false;
    });
  });

  //Custom tag filter
  $('.ask a').click(function() {
    $('#product-ask-widget').slideToggle(200);
    return false;
  });
  
//   sidebar
  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }
  var collFilters = jQuery('.category-filters-area-list li a');
  collFilters.click(function(e) {
     e.preventDefault();
    delete Shopify.queryParams.page;
    var newTags = [];
	var newURL = $(this).attr('value');
    var title = $(this).attr('title');
    
   // location.href = newURL;
    console.log(newURL);
    $(this).parent().siblings().removeClass('active');
    $(this).parent().toggleClass("active");
    var productsContainer = $('.collection-row'); 
  var productsCountContainer = $('.category-product-sorting-total');
     $.get({
        url: newURL,
       success: function (data) { 
         var newProductsCountWrapper = $(data).find(".category-product-sorting-total");
         var newProductsCountHtml = newProductsCountWrapper.html();
         
         var newProductsWrapper = $(data).find(".collection-row");
         var newProductsHtml = newProductsWrapper.html();
         productsContainer.html(newProductsHtml);
         productsCountContainer.html(newProductsCountHtml);
         console.log(data);
         if(title != 'all'){
         $('.brand-filter').hide();
         }else{
         $('.brand-filter').show();
         }
         history.pushState({
           page: newURL
         }, null, newURL);
       }
     })
    
    
    
    
  });  
//   Sidebar end
  
  //product - customer QA widget
  $(document).on('click', 'a[href="#product-ask-widget"]', function(e){
    e.preventDefault();
  	var elementId = $(this).attr('href');
    $(elementId).slideToggle(500);
  });
  
  //change currency
  var $allCurrencies = $(document).find(theme.currencySelector).siblings('ul').find('a');
  theme.currencyConverter();
  $(document).on('click', theme.currencySelector, function(){
    $('body').addClass('currency-switcher-activated');
  });
  $(document).on('click', 'body.currency-switcher-activated', function(){
    $('body').removeClass('currency-switcher-activated');
  });
  $allCurrencies.on('click', function(){
    var oldCurrency = $(document).find(theme.currencySelector).attr('data-currency');
    var newCurrency = $(this).data('value');
    var newCurrencySymbol = $(this).data('symbol') || newCurrency;
    $(document).find(theme.currencySelector).attr('data-currency', newCurrency);
    $(document).find(theme.currencySelector).html(newCurrencySymbol+' <i class="lin lin-arrow-down"></i>');
    theme.currencyConverter('select', oldCurrency, newCurrency, 'span.money', 'money_format');
  });
});
const updateAB02MenuContent = (applied) => {
  const menu1 = document.querySelector("li.dropdown.les-nouveautes");
  const menu2 = document.querySelector("li.dropdown.les-promos");
  const menu3 = document.querySelector("li.dropdown.a-propos-de-nous");
  const imageReplaceMenus = document.querySelectorAll(".required-to-replace-img");
  if(applied){
    if(menu1){
      menu1.querySelector("a").textContent = menu1.querySelector("a").dataset.testtitle;
    }
    if(menu2){
      menu2.querySelector("a").textContent = menu2.querySelector("a").dataset.testtitle;
    }
    if(menu3){
      menu3.querySelector("a").textContent = menu3.querySelector("a").dataset.testtitle;
    }
    if(imageReplaceMenus.length > 0){
      imageReplaceMenus.forEach((el) => {
          el.querySelector("img").setAttribute("src",el.dataset.rimage);
      });
    }
  }else{
    if(menu1){
      menu1.querySelector("a").textContent = menu1.querySelector("a").dataset.title;
    }
    if(menu2){
      menu2.querySelector("a").textContent = menu2.querySelector("a").dataset.title;
    }
    if(menu3){
      menu3.querySelector("a").textContent = menu3.querySelector("a").dataset.title;
    }
    if(imageReplaceMenus.length > 0){
      imageReplaceMenus.forEach((el) => {
          el.querySelector("img").setAttribute("src",el.dataset.oimage);
      });
    }
  }
   
}
const initializeBodyObservation = () => {
  const targetNode = document.body;
  const config = { attributes: true };
  const callback = function(mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if(targetNode.classList.contains("hw-abt-2-1")){
            updateAB02MenuContent(1);
        }else{
           updateAB02MenuContent(0);
        }
        window.dispatchEvent(new Event("resize"));
      }
    }
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}
document.addEventListener('DOMContentLoaded', (event) => {
  initializeBodyObservation();
    if(document.body.classList.contains("hw-abt-2-1")){
      updateAB02MenuContent(1);
    }
});